import { render, staticRenderFns } from "./failed.vue?vue&type=template&id=44e2741b"
import script from "./failed.vue?vue&type=script&lang=js"
export * from "./failed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e2741b')) {
      api.createRecord('44e2741b', component.options)
    } else {
      api.reload('44e2741b', component.options)
    }
    module.hot.accept("./failed.vue?vue&type=template&id=44e2741b", function () {
      api.rerender('44e2741b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/alert/failed.vue"
export default component.exports